export const columnsFirmware = [
  {
    accessor: 'firmwareVersion',
    contentType: 'text',
    headerType: 'text',
    position: 'left'
  },
  {
    accessor: 'latest_event',
    headerType: 'text',
    contentType: 'text',
    position: 'left'
  },
  {
    accessor: 'status',
    headerType: 'text',
    contentType: 'status',
    position: 'center'
  },
  {
    accessor: 'attempts',
    headerType: 'text',
    contentType: 'text',
    position: 'right'
  }
];
